import { useQuery } from '@tanstack/react-query';

import { apiClient } from '../config/api-client';
import { queryKeys } from '../config/query-keys';
import type { FeedAlert } from '../types';

export function useAlertsQuery(options?: { readonly enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.alerts.active(),
    queryFn: async () => {
      const result = await apiClient.get<{ data: FeedAlert[] }>('/alerts');
      return result.data.data;
    },
    staleTime: 60_000,
    enabled: options?.enabled ?? true,
  });
}

export function useActiveAlerts(options?: { readonly enabled?: boolean }): FeedAlert[] {
  const { data } = useAlertsQuery(options);
  return data ?? [];
}
